import { currentBrand } from 'configs/brands';

/**
 * Build a gateway WebSocket URL from page protocol and the brand API hostname.
 * Matches here2win: https→wss, http→ws, path `/`. Host comes from currentBrand.apiBaseUrl,
 * the same source as BackOffice HTTP, not a derived api-{frontendHost} name.
 */
export function buildBackOfficeWsUrl(pageProtocol: string, apiHost: string): string | null {
  const host = typeof apiHost === 'string' ? apiHost.trim() : '';
  if (!host) {
    return null;
  }

  const protocol = pageProtocol === 'https:' ? 'wss:' : 'ws:';
  return `${protocol}//${host}/`;
}

/**
 * Resolve the BackOffice gateway WebSocket URL for the current brand and page.
 */
export function resolveBackOfficeWsUrl(): string | null {
  if (typeof window === 'undefined' || !window.location?.protocol) {
    return null;
  }

  return buildBackOfficeWsUrl(window.location.protocol, currentBrand?.apiBaseUrl);
}
